require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./2018-social-media-image-size-guide.json") })
        }
      }, "path---2018-social-media-image-size-guide");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---2018-social-media-image-size-guide!./.cache/json/2018-social-media-image-size-guide.json
// module id = 712
// module chunks = 231608221292675